import { render, staticRenderFns } from "./BusinessUnitEdit.vue?vue&type=template&id=ef8d92da&scoped=true&"
import script from "./BusinessUnitEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d92da",
  null
  
)

export default component.exports